<template>
  <div class="topArea">
    <div>
      <span class="logo-name">{{userInfo.rootOrganizationName}}</span>
    </div>
     <div class="divTopRight">
           <span class="divTopRight_userName">
            {{userInfo.name}}
           </span>
           <el-button type="text" class="divTopRight_userName logoutBtn" @click="logout">退出</el-button>
        </div>
    <div class="divMainMenu">
      <el-menu mode="horizontal" :default-active="defaultActiveIndex"
      @select="menuSelected">
        <el-menu-item :index="item.path"  v-for="item in displayMenu" :key="item.path">
          {{item.name}}
        </el-menu-item>
      </el-menu>
    </div>
     
  </div>
</template>
<script>
import { asyncRouterMap } from "@/router";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";

export default {
  name: "topbar",
  data() {
    return {
      displayMenu: [],
      username: this.$userContext.getUserName(),
      userInfo:
      {
        rootOrganizationName:this.$userContext.getRootOrganizationName(),
        name:this.$userContext.getUserName()
      },
      defaultActiveIndex: "/weeklyReport"
    };
  },
  created() {
 
    let authorizationKeyArray = this.$userContext.getAuthorizationKeyArray();

    let filteredRouterMap = this.filterAsyncRouter(asyncRouterMap,authorizationKeyArray);

    filteredRouterMap.forEach(item => 
    {
      if (item.children && item.children.length > 0) 
      {
        this.displayMenu.push(item);
      }
    });

    //高亮当前的菜单项
    let path = this.$router.history.current.fullPath;
    let toPath = path.split("/");

    if (this.displayMenu.length == 0) 
      return;
    this.displayMenu.forEach(item => 
    {
      if (item.path === "/" + toPath[1]) 
      {
        this.defaultActiveIndex = item.path;
      }
    });
   
  },
  computed: {
    ...mapGetters(["routePath"])
  },
  watch: {
    $route: function(to, from) {
      // 路由改变时执行
      let toPath = to.path.split("/");
      this.displayMenu.forEach(item => {
        if (item.path === "/" + toPath[1]) {
          this.defaultActiveIndex = item.path;
        }
      });
     
    }
  },
  methods: {
    menuSelected(key, keyPath) {
      this.defaultActiveIndex = key;
      this.displayMenu.forEach(item => 
      {
        if (item.path === key) 
        {
          // this.$router.push({ path: key + "/" + item.children[0].path });
           this.$router.push({ path: key + item.redirect });
        }
      });
    },
    logout() {

      //确保先清除本地登录信息
      this.$userContext.clearLoginResult();

      this.$userContextApi.logout()
        .then(res => 
        {
          if (res.data.successful) 
          {
            window.location.href = "/";
            // this.$router.push({ path: "/login" });
          } 
          else 
          {
            window.location.href = "/";
            //this.$alert(res.data.Message, "提示");
          }
        })
        ;
    },

    //只需要根据权限拉出第一级菜单就可以了
    filterAsyncRouter(asyncRouterMap, authorizationKeyArray) 
    {
      //先把第一层拉出来，再判断权限
      let accessedRouters = [];
       asyncRouterMap.forEach(
         item=>
         {
           if(item.hidden)
            return false;

           accessedRouters.push(item);
         });

      let userInfo = this.$userContext.getUser();
      if(userInfo.domainAdmin) 
        return accessedRouters;

      accessedRouters = accessedRouters.filter(routeItem => 
      {
        let hasPermission = true;
        if (routeItem.role && routeItem.role.length>0) 
        {
          hasPermission = authorizationKeyArray.some
          (
            authorizationKey => routeItem.role.indexOf(authorizationKey) >= 0
          );
        } 

        return hasPermission;
      });

      return accessedRouters;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>

.topArea {
  position: absolute;
  top:0px;
  left: 0px;
  right: 0px;
  height: 60px;
  // background-color: #fff;
  
  z-index: 9000;

  .logo-name {
    font-size: 20px;
    color: #000000;
    margin-left: 40px;
    // text-align: center;h
    height: 60px;
    line-height: 60px;
    float: left;
  }
  .divMainMenu {
    // margin-left: 40px;
    // float: left;
    margin-left: 250px;
  }
  .divTopRight {
    float: right;
  }
}

.el-menu {
  background-color: transparent;
}
.el-menu.el-menu--horizontal {
  display: inline-block;
  border-bottom: none;
  min-width: 100px;
  text-align: content;
  //margin-left: 20px;
}
.el-menu--horizontal .el-menu-item {
  // float: left;
  height: 60px;
  line-height: 60px;
  margin: 0;
  // border-bottom: 2px solid transparent;
  color: #4a5d74;
  text-decoration: none;
  font-size: 16px;
  border: none;
  margin-left: 20px;
}
.el-menu--horizontal .el-menu-item.is-active {
  text-align: center;
  background: linear-gradient(#e6edf4, #ffffff);
  border-bottom:none !important;
}
.el-menu--horizontal .el-menu-item:hover {
  color: #ffa64d;
  background-color: transparent;
}
.el-dropdown {
  position: absolute;
  top: 15px;
  right: 15px;
  color: #fff;
}
.divTopRight_userName{
  display:inline-block;
  height: 60px;
  line-height: 38px;
  font-size: 16px;
  color: #4a5d74;
}
.logoutBtn{
  margin-right: 30px;
  margin-left: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/topbar.vue